import React from 'react';
import { cn } from '../../../../utils/cn';
import { ReservationsDashboardSummary } from '../../../shared/services/reservations-dashboard.data';

type StatsGridProps = {
  summary: ReservationsDashboardSummary | null;
  isLoading: boolean;
};

const formatCount = (value: number | undefined) =>
  typeof value === 'number' ? value.toLocaleString() : '—';

export const StatsGrid = ({ summary, isLoading }: StatsGridProps) => {
  const sources = summary?.sourceBookings;
  const websiteAndApp =
    sources && typeof sources.website === 'number' && typeof sources.app === 'number'
      ? sources.website + sources.app
      : undefined;

  const figures: Array<{ label: string; value: number | undefined }> = [
    { label: 'Previous Month', value: summary?.bookingsPrevMonth },
    { label: 'Current Month', value: summary?.bookingsThisMonth },
    { label: 'CX Team', value: sources?.cx },
    { label: 'Offline Sales Team', value: sources?.offlineSales },
    { label: 'Partners', value: sources?.partners },
    { label: 'Acquisition Team', value: sources?.acquisitionTeam },
    { label: "OTA's Channels", value: sources?.channelManager },
    { label: 'Website / APP', value: websiteAndApp },
    { label: 'Check-in in 3 days', value: summary?.checkInIn3Days },
    { label: 'Check-out in 3 days', value: summary?.checkOutIn3Days },
    { label: 'Currently in-house', value: summary?.currentlyInHouse }
  ];

  return (
    <section className="overflow-hidden rounded-[12px] border border-gray-200 bg-white shadow-[0_1px_2px_rgba(24,33,47,0.04)]">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
        {figures.map((figure, index) => (
          <div
            key={figure.label}
            className={cn(
              'px-6 py-5',
              index < 6 && 'border-b border-gray-200',
              (index + 1) % 6 !== 0 && 'xl:border-r xl:border-gray-200'
            )}
          >
            <p className="text-[13px] font-gilroy-medium text-neutral-400">{figure.label}</p>
            {isLoading ? (
              <span className="mt-2 block h-[28px] w-20 animate-pulse rounded bg-gray-200 motion-reduce:animate-none" />
            ) : (
              <p className="mt-1 text-[28px] font-gilroy-bold leading-none tabular-nums text-primary-700">
                {formatCount(figure.value)}
              </p>
            )}
          </div>
        ))}
        <div className="px-6 py-5">
          <p className="text-[13px] font-gilroy-medium text-neutral-400">Highest Demand Project</p>
          {isLoading ? (
            <span className="mt-2 block h-[18px] w-32 animate-pulse rounded bg-gray-200 motion-reduce:animate-none" />
          ) : (
            <>
              <p className="mt-1 text-[15px] font-gilroy-bold leading-snug text-primary-700">
                {summary?.highDemandProject?.name ?? '—'}
              </p>
              {summary?.highDemandProject?.name && (
                <p className="text-[15px] font-gilroy-bold leading-snug tabular-nums text-primary-700">
                  {summary.highDemandProject.count} bookings
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};
